var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row-align-center"},[_c('div',{staticClass:"yx-color-text-primary"},[_vm._v(_vm._s(_vm.cellValue.toString()))]),(_vm.row.parentId === '0')?_c('div',{staticClass:"role-label ml-10",staticStyle:{"display":"inline-block"}},[_vm._v("公司")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }